import { LOGIN_TO_WIX_URL, SAME_TAB_TARGET } from './constants'
import type { LoginToWixLinkData } from './linksDataTypes'
import { pickBy } from 'lodash'
import type { Link } from '@wix/public-schemas'
import { toQueryString } from './linkUtils'

const getPostSignupUrl = (postSignupUrl: string): string => {
	const placeholder = '{ifcontext}'
	if (!postSignupUrl.includes(placeholder)) {
		return postSignupUrl
	}

	const [, queryString] = postSignupUrl.split('?')
	const urlSearchParams = new URLSearchParams(queryString)

	let target
	let postSignupUrlWithContext = ''
	urlSearchParams.forEach((value, key) => {
		if (key.toLowerCase() !== 'ifcontext') {
			return
		}

		target = value.replace('#', '')
		if (/^[a-zA-Z0-9]+$/.test(target)) {
			postSignupUrlWithContext = postSignupUrl.replace(placeholder, target)
		} else {
			postSignupUrlWithContext = postSignupUrl.replace(placeholder, 'illegalContextValue')
		}
	})

	return postSignupUrlWithContext || postSignupUrl
}

export const handleLoginToWixLink = (linkData: LoginToWixLinkData): Link => {
	const { sendMail, mailTemplate, userColor, loginCompName } = linkData
	const postLoginUrl = linkData.postLoginUrl || ''
	const postSignupUrl = getPostSignupUrl(linkData.postSignupUrl || '')
	const dialog = linkData.dialog || 'showLogin'

	const view = dialog === 'createUser' ? 'sign-up' : dialog

	const urlParamsObj = pickBy(
		{
			postLogin: postLoginUrl,
			postSignUp: postSignupUrl,
			view,
			sendEmail: sendMail === undefined ? '' : `${sendMail}`,
			welcomeEmailTemplate: mailTemplate,
			userColor,
			loginCompName,
			referralInfo: loginCompName,
		},
		(param) => !!param
	)

	const queryParamsStr = toQueryString(urlParamsObj)
	return {
		href: `${LOGIN_TO_WIX_URL}${queryParamsStr}`,
		target: SAME_TAB_TARGET,
	}
}
